import { TooltipProps, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
interface AppTooltipProps extends TooltipProps {
  fontSize?: number;
}

const AppTooltip: FC<AppTooltipProps> = ({ fontSize, ...prop }) => {
  const { t } = useTranslation();
  return (
    <Tooltip
      {...prop}
      title={
        <Typography fontSize={fontSize ?? 16}>
          {t(prop.title!.toString())}
        </Typography>
      }
    />
  );
};

export default AppTooltip;
